import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../../App';
export const GetSchedulerList = (where: string) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `capacity?where=${where}`
  );
};
